export const ROLE_LABELS = {
  admin: "Administrateur",
  responsable: "Responsable conditionnement",
  operateur: "Opérateur",
  chauffeur: "Chauffeur",
};

export const GESTION = ["admin", "responsable"];
export const SAISIE = ["admin", "responsable", "operateur"];
export const ALL = ["admin", "responsable", "operateur", "chauffeur"];

export function homeFor(role) {
  if (role === "operateur") return "/nouvelle-palette";
  if (role === "chauffeur") return "/bl";
  return "/dashboard";
}

export const can = (user, roles) => !!user && roles.includes(user.role);
